export default function RemoveWhiteSpace() {
  return function(value) {
    return !value ? '' : value.replace(/ /g, '');
  };
}
